import React, { useState, useEffect } from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import '../../Css/dashboard.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);

const Dashboard = () => {
  const [factureStats, setFactureStats] = useState(null);
  const [reservationStats, setReservationStats] = useState(null);
  const [reservationStatus, setReservationStatus] = useState(null);
  const [hotelSalesData, setHotelSalesData] = useState(null);
  const [organismeSalesData, setOrganismeSalesData] = useState(null);

  const token = localStorage.getItem('token');
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchFactureStats = async () => {
      const response = await fetch(`${apiUrl}/api/facture-stats`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setFactureStats(data);
    };

    const fetchReservationStats = async () => {
      const response = await fetch(`${apiUrl}/api/reservation-stats`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      const data = await response.json();
      const { statusBreakdown } = data;
      setReservationStatus(statusBreakdown);
      setReservationStats(data);
    };

    const fetchHotelSalesData = async () => {
      const response = await fetch(`${apiUrl}/api/hotels/solde`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setHotelSalesData(data);
    };


    const fetchOrganismeSalesData = async () => {
      const response = await fetch(`${apiUrl}/api/organismes/solde`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setOrganismeSalesData(data);
    };


    fetchFactureStats();
    fetchReservationStats();
    fetchHotelSalesData();
    fetchOrganismeSalesData();
  }, [apiUrl, token]);

  // Format numbers to currency, return empty string if value is 0 or undefined
  const formatedNumber = (num) => {
    return num === 0 || num === '0' || num === null || num === undefined
      ? ''
      : parseFloat(num).toLocaleString('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
  };

  // Prepare data for months
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  // Process hotel sales data to ensure every hotel has sales data for all 12 months
  const processHotelSalesData = (data) => {
    const hotels = {};

    data.forEach((item) => {
      if (!hotels[item.selectedHotel]) {
        hotels[item.selectedHotel] = new Array(12).fill(0); // Initialize with 0 sales for each month
      }

      if (item.month >= 1 && item.month <= 12) {
        hotels[item.selectedHotel][item.month - 1] += item.totalSolde;
      }
    });

    return Object.keys(hotels).map((hotel) => ({
      selectedHotel: hotel,
      sales: hotels[hotel],
      totalSolde: hotels[hotel].reduce((acc, cur) => acc + cur, 0),
    }));
  };





    // Process hotel sales data to ensure every hotel has sales data for all 12 months
    const processOrganismeSalesData = (data) => {
      const organismes = {};
  
      data.forEach((item) => {
        if (!organismes[item.selectedorganisme]) {
          organismes[item.selectedorganisme] = new Array(12).fill(0); // Initialize with 0 sales for each month
        }
  
        if (item.month >= 1 && item.month <= 12) {
          organismes[item.selectedorganisme][item.month - 1] += item.totalSolde;
        }
      });
  
      return Object.keys(organismes).map((organisme) => ({
        selectedorganisme: organisme,
        sales: organismes[organisme],
        totalSolde: organismes[organisme].reduce((acc, cur) => acc + cur, 0),
      }));
    };




  // If we have sales data, process it
  const processedSalesData = hotelSalesData ? processHotelSalesData(hotelSalesData) : [];


  // If we have sales data, process it
  const processedOrganismeSalesData = organismeSalesData ? processOrganismeSalesData(organismeSalesData) : [];


  
  // Calculate the column totals (for each month and totalSolde)
  const calculateColumnTotals = () => {
    const totals = new Array(13).fill(0); // 12 months + 1 for totalSolde
    processedSalesData.forEach((hotel) => {
      totals[0] += hotel.totalSolde; // Sum totalSolde
      hotel.sales.forEach((sales, monthIndex) => {
        totals[monthIndex + 1] += sales; // Sum sales for each month
      });
    });
    return totals;
  };

  const columnTotals = calculateColumnTotals();




    // Calculate the column totals (for each month and totalSolde)
    const calculateOrganismeColumnTotals = () => {
      const totals = new Array(13).fill(0); // 12 months + 1 for totalSolde
      processedOrganismeSalesData.forEach((organisme) => {
        totals[0] += organisme.totalSolde; // Sum totalSolde
        organisme.sales.forEach((sales, monthIndex) => {
          totals[monthIndex + 1] += sales; // Sum sales for each month
        });
      });
      return totals;
    };
  
    const columnOrganismeTotals = calculateOrganismeColumnTotals();





  return (
    <div className="Dashboard__container">
      <div className="Dashboard__header">Dashboard</div>

      <div className="Dashboard__stats-section">
        <div className="Dashboard__stat-card">
          <h3>Total Factures</h3>
          <p>{factureStats ? factureStats.totalFactures : null}</p>
        </div>

        <div className="Dashboard__stat-card">
          <h3>Total vente</h3>
          <p>{formatedNumber(factureStats ? factureStats.totalSolde : null)} TND</p>
        </div>

        <div className="Dashboard__stat-card">
          <h3>Total Achat</h3>
          <p>{formatedNumber(factureStats ? factureStats.montantAchatTotal : null)} TND</p>
        </div>

        <div className="Dashboard__stat-card Dashboard__stat-card--commission">
          <h3>Total Commission</h3>
          <p>{formatedNumber(factureStats ? factureStats.commissionTotal : null)} TND</p>
        </div>
      </div>

      <div className="Dashboard__stats-section">
        <div className="Dashboard__stat-card">
          <h3>Total Reservations</h3>
          <p>{reservationStats ? reservationStats.totalReservations : null}</p>
        </div>

        <div className="Dashboard__stat-card">
          <h3>Total Check In</h3>
          <p>{reservationStatus ? reservationStatus["Check-In"] : null}</p>
        </div>

        <div className="Dashboard__stat-card">
          <h3>Total Check Out</h3>
          <p>{reservationStatus ? reservationStatus["Check-Out"] : null}</p>
        </div>

        <div className="Dashboard__stat-card">
          <h3>Total Réservation Annulée</h3>
          <p>{reservationStatus ? reservationStatus["Annulée"] : null}</p>
        </div>

        <div className="Dashboard__stat-card">
          <h3>Total Réservation Confirmée</h3>
          <p>{reservationStatus ? reservationStatus["Confirmée"] : null}</p>
        </div>
      </div>

      {/* Display Hotel Sales Data in a Table */}
      {processedSalesData && processedSalesData.length > 0 && (
        <div className="Dashboard__table-container">
          <h3>Sales by Hotel</h3>
          <table className="Dashboard__table">
            <thead>
              <tr>
                <th>Hotel Name</th>
                <th>Solde</th>
                {months.map((month, index) => (
                  <th key={index}>{month}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {processedSalesData.map((hotel, hotelIndex) => (
                <tr key={hotelIndex}>
                  <td>{hotel.selectedHotel}</td>
                  <td>{formatedNumber(hotel.totalSolde)}</td>
                  {hotel.sales.map((sales, monthIndex) => (
                    <td key={monthIndex}>{formatedNumber(sales)}</td>
                  ))}
                </tr>
              ))}
              <tr>
              <td style={{padding: '7px'}}></td>
              </tr>
              <tr>
              <td><strong>Total</strong></td>
                <td style={{fontWeight: 'bold'}}>{formatedNumber(columnTotals[0])}</td> {/* Total Solde */}
                {columnTotals.slice(1, 13).map((total, monthIndex) => (
                  <td key={monthIndex} style={{fontWeight: 'bold'}}>{formatedNumber(total)}</td> // Display totals for each month
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      )}



        {/* Display Hotel Sales Data in a Table */}
        {processedOrganismeSalesData && processedOrganismeSalesData.length > 0 && (
        <div className="Dashboard__table-container">
          <h3>Sales by Organisme</h3>
          <table className="Dashboard__table">
            <thead>
              <tr>
                <th>Organisme Name</th>
                <th>Solde</th>
                {months.map((month, index) => (
                  <th key={index}>{month}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {processedOrganismeSalesData.map((organisme, organismeIndex) => (
                <tr key={organismeIndex}>
                  <td>{organisme.selectedorganisme}</td>
                  <td>{formatedNumber(organisme.totalSolde)}</td>
                  {organisme.sales.map((sales, monthIndex) => (
                    <td key={monthIndex}>{formatedNumber(sales)}</td>
                  ))}
                </tr>
              ))}
              <tr>
              <td style={{padding: '7px'}}></td>
              </tr>
              <tr>
              <td><strong>Total</strong></td>
                <td style={{fontWeight: 'bold'}}>{formatedNumber(columnOrganismeTotals[0])}</td> {/* Total Solde */}
                {columnOrganismeTotals.slice(1, 13).map((total, monthIndex) => (
                  <td key={monthIndex} style={{fontWeight: 'bold'}}>{formatedNumber(total)}</td> // Display totals for each month
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
